module.exports = __webpack_public_path__ + "img/Groupe 90.a9fdf743.svg";